<template>
  <AppLayout />
</template>

<script setup lang="ts"></script>

<style>
  /* completely off-screen */
  textarea.g-recaptcha-response {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: 0 !important;
    overflow: hidden !important;
    clip: rect(0 0 0 0) !important;
    clip-path: inset(50%) !important;
    border: 0 !important;
    white-space: nowrap !important;
  }
</style>
